// Static brand/display configuration for the SDL booking page.
// Services and time slots are no longer sourced from here — they are fetched
// live from the backend API on page load. This file retains brand metadata
// (colours, display name) only.

export const SITE_CONFIG = {
  display_name: "Specialist Dental London",
  audiences: [
    {
      key: "patient",
      accent: "#C8A86B",
      accent_bg: "#201914",
    },
  ],
};
